;(function () {
  function bootPreUpsellDynamicRuntime() {
    if (window.__bbePreUpsellDynamicRuntimeInit) return

    const modal = document.querySelector("pre-upsell-modal")
    if (!modal) return

    window.__bbePreUpsellDynamicRuntimeInit = true

  function getModal() {
    return document.querySelector("pre-upsell-modal")
  }

  function getCheckoutUrl() {
    const modalEl = document.querySelector("pre-upsell-modal")
    return modalEl?.dataset.checkoutUrl || "/checkout"
  }
  const OFFERS_URL = "/apps/bbe-checkout-app/api/pre-upsell/offers"
  const MARKET_AVAILABILITY_URL = "/apps/bbe-checkout-app/api/market-availability"
  const EVENT_URL = "/apps/bbe-checkout-app/api/pre-upsell/event"
  const CART_VIEW_URL = "/apps/bbe-checkout-app/api/cart/view"
  const OFFER_MINT_URL = "/apps/bbe-checkout-app/api/offer/mint"
  /** Must be > app `REQUEST_TIMEOUT_MS` (3000) in api.pre-upsell.offers.ts, so the app's own timeout answers first. */
  const OFFERS_TIMEOUT_MS = 3500
  const MARKET_AVAILABILITY_TIMEOUT_MS = 800
  const OFFER_MINT_STORAGE_PREFIX = "bbe_offer_mint:"

  function utcDayKeyMint() {
    const d = new Date()
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()))
      .toISOString()
      .slice(0, 10)
  }

  function offerMintCacheKey(offerId, variantId, aq) {
    return `${OFFER_MINT_STORAGE_PREFIX}${offerId}:${variantId}::${aq || 1}:${utcDayKeyMint()}`
  }

  function readOfferMintCache(key) {
    try {
      return sessionStorage.getItem(key)
    } catch {
      return null
    }
  }

  function writeOfferMintCache(key, token) {
    try {
      sessionStorage.setItem(key, token)
    } catch {
      /* ignore */
    }
  }

  /** Fire-and-forget PPUP premint — never awaited on ATC path. */
  function premintPpupOffers(offers) {
    if (!Array.isArray(offers) || !offers.length) return
    const bodyOffers = []
    for (const o of offers) {
      const offerId = o.offerId || `ppup-${o.variantId || o.productId || "x"}`
      const variantId = o.variantId
      if (!variantId) continue
      const key = offerMintCacheKey(offerId, variantId, 1)
      if (readOfferMintCache(key)) continue
      bodyOffers.push({
        offerId,
        variantId: String(variantId),
        aq: 1,
        type: "ppup",
        pct: config.ppupDiscountPct > 0 ? config.ppupDiscountPct : Number(getModal()?.dataset?.ppupDiscountPercent) || 30,
        _key: key,
      })
    }
    postOfferMint(bodyOffers)
  }

  function postOfferMint(bodyOffers) {
    if (!bodyOffers.length) return
    fetch(OFFER_MINT_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        offers: bodyOffers.map(({ offerId, variantId, aq, type, pct }) => ({
          offerId,
          variantId,
          aq,
          type,
          pct,
        })),
      }),
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const results = data?.results
        if (!Array.isArray(results)) return
        results.forEach((r, i) => {
          if (r?.ok && r.token && bodyOffers[i]) {
            writeOfferMintCache(bodyOffers[i]._key, r.token)
          }
        })
      })
      .catch(() => {})
  }
  const RECENTLY_VIEWED_KEY = "bbe_ppup_recently_viewed_product_ids"
  const VISITOR_KEY_STORAGE = "bbe_ppup_visitor_key"
  const SESSION_KEY_STORAGE = "bbe_ppup_session_id"
  const UTM_SESSION_KEY = "bbe_ppup_utm"
  const LANDING_SESSION_KEY = "bbe_ppup_landing_path"
  const REFERRER_SESSION_KEY = "bbe_ppup_referrer"
  // Externally minted reward codes (Rivo/Swell/SMS) are still non-combinable
  // (productDiscounts:false) — they live in the Rivo/Swell dashboards, not the
  // BBE app, so they cannot be flipped to combine with the PPUP product
  // discount. When one is on the cart, Shopify silently drops one discount at
  // checkout, so we suppress the PPUP for these only. Normal shopper codes
  // (WELCOME15, BOGO, MEMBER25, etc.) were flipped to productDiscounts:true on
  // 2026-07-08 and combine cleanly — the PPUP should show for them.
  // NOTE: node-creation scripts in ~/beautybyearth still hard-code
  // combinesWith:false; if a discount node is ever recreated from those, the
  // combinable assumption breaks and this guard would need widening again.
  const NON_COMBINABLE_CODE_PATTERN = /^\s*(RWD|RAF|FIVE|SMSBE)/i
  const PPUP_ADDED_LABEL = "✓ ADDED"
  const PPUP_FREE_GIFT_LIMIT_MSG = "You can only claim one free gift."
  const PPUP_ADD_ERROR_FALLBACK_MSG = "Couldn't add — please try again."
  const PPUP_ADD_ERROR_RESET_MS = 3500

  /** LP modal gift (`_is_lp_upsells_gift`) + PPUP free row (`_is_pre_upsell`). */
  function isLpPpUpsellFreeLine(item) {
    if (!item?.properties || typeof item.properties !== "object") return false
    const p = item.properties
    if (p._is_lp_upsells_gift === "true" || p._is_lp_upsells_gift === true) return true
    return p._is_pre_upsell === "true" || p._is_pre_upsell === true
  }

  function countLpPpUpsellFreeLines(cart) {
    if (!cart?.items?.length) return 0
    return cart.items.reduce((total, item) => {
      if (!isLpPpUpsellFreeLine(item)) return total
      const qty = Number(item.quantity)
      return total + (Number.isFinite(qty) && qty > 0 ? qty : 1)
    }, 0)
  }

  function syncPpupFreeCardLimits(root) {
    const scope = root instanceof Element ? root : getModal()
    if (!scope) return

    const atLimit = countLpPpUpsellFreeLines(window.liquidAjaxCart?.cart) >= 1
    scope.querySelectorAll('[data-ppup-free-item="true"]').forEach((card) => {
      const btn = card.querySelector("button[data-upsell-add]")
      const alreadyAdded = card.classList.contains("added")
      const blocked = atLimit && !alreadyAdded
      if (!(btn instanceof HTMLButtonElement)) return
      btn.disabled = blocked
      if (blocked) {
        btn.setAttribute("aria-disabled", "true")
        btn.title = PPUP_FREE_GIFT_LIMIT_MSG
      } else if (!btn.classList.contains("is-added")) {
        btn.removeAttribute("aria-disabled")
        btn.removeAttribute("title")
      }
    })
  }

  window.bbeCountLpPpUpsellFreeLines = countLpPpUpsellFreeLines
  window.bbeSyncPpupFreeCardLimits = syncPpupFreeCardLimits

  // Advertise the NODE's live percentage (mirrored to a shop metafield by
  // scripts/sync-upsell-discount-nodes.mjs), falling back to the schema value.
  // Schema -> node is eventually consistent, so between a Theme Editor % change
  // and the next sync the schema value would promise a discount checkout has not
  // caught up to. The mirror is written as 0 when the node is not ACTIVE.
  const rawMirrorPct = parseInt(modal.dataset.ppupMirrorPct, 10)
  const rawSchemaPct = parseInt(modal.dataset.ppupDiscountPercent, 10)
  const rawPpupDiscountPct = Number.isFinite(rawMirrorPct)
    ? rawMirrorPct
    : rawSchemaPct
  const ppupDiscountPct = Number.isFinite(rawPpupDiscountPct)
    ? Math.min(50, Math.max(0, rawPpupDiscountPct))
    : 30

  /**
   * Effective PPUP eligibility, mirrored from the cart transform's own gate.
   * Cards are built here from the app's offer API, so no Liquid guard runs for
   * them — without this a card can advertise a % checkout refuses (a hi_ltv
   * product that can only be added as a subscription is the live example).
   * Empty/absent set means "no signal", and the display FAILS CLOSED.
   */
  const ppupEligibleIds = new Set(
    String(modal.dataset.ppupEligibleIds || "")
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean),
  )
  function isPpupProductEligible(offer) {
    if (!ppupEligibleIds.size) return false
    const raw = offer && (offer.productId ?? offer.product_id ?? offer.id)
    if (raw == null) return false
    const numeric = String(raw).match(/(\d+)(?!.*\d)/)
    return numeric ? ppupEligibleIds.has(numeric[1]) : false
  }

  // The app draws a session-stable random 4 (one balanced row). The theme
  // "Number of upsell items" setting is archived so a saved 3 cannot clip it.
  const ppupMaxOffers = 4

  const config = {
    enableDynamic: modal.dataset.enableDynamic === "true",
    marketHandle: modal.dataset.marketHandle || null,
    country: modal.dataset.country || (window.Shopify && window.Shopify.country) || "US",
    currency: modal.dataset.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD",
    useScriptDiscount: modal.dataset.useScriptDiscount === "true",
    ppupDiscountPct,
    ppupDiscountRate: ppupDiscountPct / 100,
    ppupBadgeStyle: modal.dataset.ppupBadgeStyle === "dollar" ? "dollar" : "percent",
    maxOffers: ppupMaxOffers,
  }

  // --- Layout: grid_v1 (current) | list_v2 -----------------------------------
  // Precedence: page Off → non-live theme / editor (preview: ?ppup_layout= → page
  // pin → site → grid; never split) → page pin → site → A/B split → grid.
  // Resolved once per page view; html[data-ppup-layout] drives the CSS and the
  // value rides on the offers request, events, and line properties.
  const PPUP_LAYOUTS = ["grid_v1", "list_v2"]
  const LAYOUT_STORAGE_PREFIX = "bbe_ppup_layout:"
  let ppupLayoutState = null
  /** From the /cart.js already fetched for offers; joins events to Admin `order.cart_token`. */
  let ppupCartToken = null
  let ppupPageOffReported = false

  function fnv1a32(str) {
    let h = 0x811c9dc5
    for (let i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i)
      h = Math.imul(h, 0x01000193) >>> 0
    }
    return h >>> 0
  }

  function getPpupPageFlag() {
    return document.querySelector("[data-bbe-ppup-page]")
  }

  /**
   * Theme editor or any non-live theme (preview link, unpublished, development).
   * These visits never join the split: no sticky assignment, no test id on events.
   * `Shopify.theme.role` comes from content_for_header; `preview_theme_id` covers
   * preview links if the role is ever missing.
   */
  function isNonLiveThemeContext() {
    if (window.Shopify?.designMode) return true
    const role = window.Shopify?.theme?.role
    if (role) return role !== "main"
    try {
      return new URLSearchParams(window.location.search).has("preview_theme_id")
    } catch {
      return false
    }
  }

  function readPreviewLayout() {
    try {
      const value = new URLSearchParams(window.location.search).get("ppup_layout")
      return PPUP_LAYOUTS.includes(value) ? value : null
    } catch {
      return null
    }
  }

  function getLayoutExperimentId() {
    return (getModal() || modal).dataset.ppupLayoutExperiment || "ppup-layout-01"
  }

  function resolveSplitLayout(experimentId, splitPct) {
    const storageKey = LAYOUT_STORAGE_PREFIX + experimentId
    try {
      const stored = localStorage.getItem(storageKey)
      if (PPUP_LAYOUTS.includes(stored)) return stored
    } catch {
      /* storage blocked — fall through to the deterministic bucket */
    }
    const bucket = fnv1a32(experimentId + ":" + getOrCreateVisitorKey()) % 100
    const layout = bucket < splitPct ? "list_v2" : "grid_v1"
    try {
      localStorage.setItem(storageKey, layout)
    } catch {
      /* ignore */
    }
    return layout
  }

  function resolvePpupLayout() {
    const flag = getPpupPageFlag()
    const pageSetting = flag?.dataset.ppupLayout || "inherit"
    const pageKey = flag?.dataset.pageKey || null
    if (pageSetting === "off") return { layout: "off", source: "page", pageKey }

    const site = modal.dataset.ppupLayoutSite
    if (isNonLiveThemeContext()) {
      const pinned = PPUP_LAYOUTS.includes(pageSetting) ? pageSetting : PPUP_LAYOUTS.includes(site) ? site : "grid_v1"
      return { layout: readPreviewLayout() || pinned, source: "preview", pageKey }
    }
    if (PPUP_LAYOUTS.includes(pageSetting)) return { layout: pageSetting, source: "page", pageKey }

    if (site === "split") {
      const experimentId = getLayoutExperimentId()
      const rawPct = parseInt(modal.dataset.ppupLayoutSplit, 10)
      const splitPct = Number.isFinite(rawPct) ? Math.min(100, Math.max(0, rawPct)) : 50
      return { layout: resolveSplitLayout(experimentId, splitPct), source: "split", pageKey }
    }
    return { layout: PPUP_LAYOUTS.includes(site) ? site : "grid_v1", source: "site", pageKey }
  }

  function getPpupLayoutState() {
    if (!ppupLayoutState) ppupLayoutState = resolvePpupLayout()
    return ppupLayoutState
  }

  /** Assigned list_v2 and its assets are loaded (see ensureListAssets). */
  function isListLayout() {
    return ppupListActive
  }

  function applyPpupLayoutAttribute() {
    const { layout } = getPpupLayoutState()
    document.documentElement.dataset.ppupLayout = layout === "off" ? "grid_v1" : layout
  }

  /**
   * Request/event fields. `layoutVariant` is the assigned layout (intent-to-treat),
   * null on Off pages (no popup shown). `layoutTestId` names the split test.
   */
  function getPpupLayoutFields() {
    const { layout, source, pageKey } = getPpupLayoutState()
    return {
      layoutVariant: layout === "off" ? null : layout,
      layoutSource: source,
      layoutTestId: source === "split" ? getLayoutExperimentId() : null,
      pageKey,
      cartToken: ppupCartToken,
    }
  }

  /** One `suppressed` / `page_off` event per page view, from whichever path sees Off first. */
  function reportPpupPageOff() {
    if (ppupPageOffReported) return
    ppupPageOffReported = true
    postOfferEvent("suppressed", null, null, { reason: "page_off" })
  }
  window.bbeReportPpupPageOff = reportPpupPageOff

  let checkoutExitHandlersBound = false

  function getPpupOverlay() {
    return document.querySelector(".pre-upsell__overlay")
  }

  function getPpupItemsContainer() {
    return (
      getModal()?.querySelector("[data-pre-upsell-paid-grid]") ||
      getModal()?.querySelector(".pre-upsell__items")
    )
  }

  function cartAddViaAjaxCart(body, options) {
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === "function") {
      return new Promise((resolve, reject) => {
        window.liquidAjaxCart.add(body, {
          ...options,
          lastCallback: (requestState) => {
            const cartBody = requestState?.responseData?.body
            if (cartBody?.status) {
              reject(new Error(cartBody.description || "cart add failed"))
              return
            }
            if (!requestState?.responseData?.ok) {
              reject(new Error("cart add failed"))
              return
            }
            resolve(cartBody)
          },
        })
      })
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body),
    }).then((res) => {
      if (!res.ok) throw new Error("cart add failed")
      return res.json()
    }).then((cartBody) => {
      if (cartBody?.status) throw new Error(cartBody.description || "cart add failed")
      return cartBody
    })
  }

  let activeOfferResponse = null
  let cachedDynamicOffers = null
  let checkoutInterceptBusy = false
  let checkoutInterceptQueued = false

  function readPageContext() {
    const el = document.getElementById("pre-upsell-page-context")
    if (!el) return null
    try {
      return JSON.parse(el.textContent || "null")
    } catch (e) {
      return null
    }
  }

  function getOrCreateVisitorKey() {
    try {
      const existing = localStorage.getItem(VISITOR_KEY_STORAGE)
      if (existing) return existing
      const key = "v_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10)
      localStorage.setItem(VISITOR_KEY_STORAGE, key)
      return key
    } catch (e) {
      return "v_fallback_" + Date.now()
    }
  }

  function getOrCreateSessionId() {
    try {
      const existing = sessionStorage.getItem(SESSION_KEY_STORAGE)
      if (existing) return existing
      const id = "s_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10)
      sessionStorage.setItem(SESSION_KEY_STORAGE, id)
      return id
    } catch (e) {
      return "s_fallback_" + Date.now()
    }
  }

  /** Shared identity for offers API, cart/view, and event ingest (spec 07). */
  function resolvePpupIdentity() {
    return {
      sessionId: getOrCreateSessionId(),
      visitorKey: getOrCreateVisitorKey(),
    }
  }

  function captureAttributionOnLoad() {
    try {
      const params = new URLSearchParams(window.location.search)
      const utm = {
        source: params.get("utm_source") || null,
        medium: params.get("utm_medium") || null,
        campaign: params.get("utm_campaign") || null,
      }
      if (utm.source || utm.medium || utm.campaign) {
        sessionStorage.setItem(UTM_SESSION_KEY, JSON.stringify(utm))
      }
      if (!sessionStorage.getItem(LANDING_SESSION_KEY)) {
        sessionStorage.setItem(LANDING_SESSION_KEY, window.location.pathname + window.location.search)
      }
      if (!sessionStorage.getItem(REFERRER_SESSION_KEY) && document.referrer) {
        sessionStorage.setItem(REFERRER_SESSION_KEY, document.referrer)
      }
    } catch (e) {
      /* ignore */
    }

    const pageCtx = readPageContext()
    if (pageCtx && pageCtx.pageProductId) {
      recordRecentlyViewedProductId(String(pageCtx.pageProductId))
    }
  }

  function recordRecentlyViewedProductId(productId) {
    if (!productId) return
    try {
      const raw = localStorage.getItem(RECENTLY_VIEWED_KEY)
      let ids = raw ? JSON.parse(raw) : []
      if (!Array.isArray(ids)) ids = []
      ids = ids.filter((id) => String(id) !== String(productId))
      ids.unshift(String(productId))
      ids = ids.slice(0, 10)
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(ids))
    } catch (e) {
      /* ignore */
    }
  }

  function getRecentlyViewedProductIds() {
    try {
      const raw = localStorage.getItem(RECENTLY_VIEWED_KEY)
      const ids = raw ? JSON.parse(raw) : []
      return Array.isArray(ids) ? ids.map(String) : []
    } catch (e) {
      return []
    }
  }

  function getStoredUtm() {
    try {
      const raw = sessionStorage.getItem(UTM_SESSION_KEY)
      if (!raw) return { source: null, medium: null, campaign: null }
      const parsed = JSON.parse(raw)
      return {
        source: parsed.source || null,
        medium: parsed.medium || null,
        campaign: parsed.campaign || null,
      }
    } catch (e) {
      return { source: null, medium: null, campaign: null }
    }
  }

  function getDeviceType() {
    const w = window.innerWidth || 0
    if (w <= 768) return "mobile"
    if (w <= 1024) return "tablet"
    return "desktop"
  }

  function getCustomerType() {
    const pageCtx = readPageContext()
    if (pageCtx && pageCtx.customerOrdersCount === 0) {
      return "new"
    }
    if (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) {
      return "returning"
    }
    return "guest"
  }

  function formatMoney(amount, currency) {
    const n = Number(amount)
    if (!Number.isFinite(n)) return ""
    if (typeof window.Shopify !== "undefined" && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(Math.round(n * 100), window.money_format || "${{amount}}")
      } catch (e) {
        /* fall through */
      }
    }
    return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || config.currency }).format(n)
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" })
    if (!res.ok) throw new Error("cart fetch failed")
    const cart = await res.json()
    if (cart?.token) ppupCartToken = String(cart.token)
    return cart
  }

  function extractBundleMaps(cart) {
    const bundleIdToLines = {}
    cart.items.forEach((item) => {
      const props = item.properties || {}
      const bundleId = props._bundle_id
      if (bundleId) {
        if (!bundleIdToLines[bundleId]) bundleIdToLines[bundleId] = []
        bundleIdToLines[bundleId].push(item)
      }
    })
    return bundleIdToLines
  }

  function buildCartLines(cart) {
    const bundleMaps = extractBundleMaps(cart)
    return cart.items.map((item) => {
      const props = item.properties || {}
      const bundleId = props._bundle_id
      const bundleComponentProductIds = []
      const bundleComponentVariantIds = []
      const bundleComponentSkus = []

      if (props._bundle_parent && bundleId && bundleMaps[bundleId]) {
        bundleMaps[bundleId].forEach((child) => {
          if (child.id !== item.id) {
            bundleComponentProductIds.push(String(child.product_id))
            bundleComponentVariantIds.push(String(child.variant_id))
            if (child.sku) bundleComponentSkus.push(String(child.sku))
          }
        })
      }

      return {
        productId: String(item.product_id),
        variantId: String(item.variant_id),
        sku: item.sku || null,
        quantity: item.quantity,
        bundleComponentProductIds,
        bundleComponentVariantIds,
        bundleComponentSkus,
      }
    })
  }

  function buildOffersRequestBody(cart) {
    const cartValue = Number(cart.total_price || 0) / 100
    const identity = resolvePpupIdentity()
    return {
      contractVersion: "ppup-v1",
      sessionId: identity.sessionId,
      visitorKey: identity.visitorKey,
      country: config.country,
      marketHandle: config.marketHandle,
      customerType: getCustomerType(),
      cartValue,
      currency: cart.currency || config.currency,
      device: getDeviceType(),
      cartLines: buildCartLines(cart),
      recentlyViewedProductIds: getRecentlyViewedProductIds(),
      utm: getStoredUtm(),
      referrer: sessionStorage.getItem(REFERRER_SESSION_KEY) || document.referrer || null,
      landingPath: sessionStorage.getItem(LANDING_SESSION_KEY) || window.location.pathname,
      // No static collection popup to fall back to: app errors come back as
      // `suppress` and the shopper goes straight to checkout.
      staticRetired: true,
      ...getPpupLayoutFields(),
    }
  }

  async function fetchOffersWithTimeout(cart) {
    if (!cart) return null
    const body = buildOffersRequestBody(cart)
    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), OFFERS_TIMEOUT_MS)
    try {
      const res = await fetch(OFFERS_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(body),
        signal: controller.signal,
      })
      if (!res.ok) return null
      return res.json()
    } catch (e) {
      return null
    } finally {
      clearTimeout(timer)
    }
  }

  // Returns true only when the cart carries a non-combinable reward code
  // (see NON_COMBINABLE_CODE_PATTERN). Combinable shopper codes and automatic
  // promos no longer suppress the PPUP.
  function hasNonCombinableRewardDiscount(cart) {
    try {
      if (cart.discount_codes && cart.discount_codes.length > 0) {
        const rewardCodes = cart.discount_codes.filter(function (entry) {
          if (entry.applicable === false) return false
          const code = String(entry.code || "").trim()
          if (!code) return false
          return NON_COMBINABLE_CODE_PATTERN.test(code)
        })
        if (rewardCodes.length > 0) return true
      }

      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        const rewardApps = cart.cart_level_discount_applications.filter(function (discount) {
          const title = String(discount.title || discount.description || "")
          return NON_COMBINABLE_CODE_PATTERN.test(title)
        })
        if (rewardApps.length > 0) return true
      }

      return false
    } catch (e) {
      return false
    }
  }

  function normalizeVariantId(id) {
    const s = String(id || "")
    const match = s.match(/(\d+)$/)
    return match ? match[1] : s
  }

  function findCartLineByVariantId(cart, variantId) {
    const normalized = normalizeVariantId(variantId)
    if (!normalized) return null
    return (cart?.items || []).find((line) => String(line.variant_id) === normalized) || null
  }

  function syncDynamicAddedFromCart(cart) {
    const scope = getModal()
    const items = cart?.items
    if (!scope || !items?.length) return

    scope.querySelectorAll("[data-ppup-dynamic-item]").forEach((card) => {
      const paidLine = findCartLineByVariantId(cart, card.dataset.variantId)
      if (paidLine && typeof window.bbeSetPreUpsellAddedState === "function") {
        window.bbeSetPreUpsellAddedState(card, paidLine)
      }
    })
  }

  function variantIdFromMarketAvailabilityResult(result) {
    const rawId =
      result?.variant_id_numeric ??
      result?.variantIdNumeric ??
      result?.variant_id ??
      result?.variantId
    if (rawId == null) return ""
    return normalizeVariantId(rawId)
  }

  function isMarketAvailabilityPurchasable(result) {
    if (!result || typeof result !== "object") return false
    const marketState = String(result.market_state ?? result.marketState ?? "").trim().toLowerCase()
    const hidden =
      marketState === "hide" ||
      result.hidden === true ||
      result.buy_box_hidden === true ||
      result.buyBoxHidden === true ||
      result.in_market_catalog === false
    if (hidden) return false
    // Same contract as bbe-market-availability-gate: the app's is_purchasable
    // when present, otherwise warehouse stock. Do not apply the low-inventory
    // threshold or effective_available here. Discount tokens are unchanged.
    if (result.is_purchasable === false) return false
    if (result.is_purchasable === true) return true
    if (["oos", "out_of_stock", "sold_out", "unavailable"].includes(marketState)) return false
    if (result.in_region_warehouse === false) return false
    if (result.in_region_warehouse === true) return true
    return false
  }

  async function filterByMarketAvailability(offers) {
    if (!offers || offers.length === 0) return []
    const variantIds = offers.map((o) => o.variantId).filter(Boolean)
    if (variantIds.length === 0) return offers

    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), MARKET_AVAILABILITY_TIMEOUT_MS)
    try {
      const res = await fetch(MARKET_AVAILABILITY_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          variant_ids: variantIds,
          country: config.country,
          market_handle: config.marketHandle,
          surface: "pre_purchase_popup_upsell",
          bypass_cache: true,
          contract_version: "v1",
        }),
        signal: controller.signal,
      })
      if (!res.ok) return offers
      const data = await res.json()
      // Fail open only for errors, timeouts, and variants the service didn't
      // answer for; an explicit "not purchasable" drops the offer.
      const answered = new Set()
      const purchasable = new Set()
      ;(data.results || []).forEach((r) => {
        const id = variantIdFromMarketAvailabilityResult(r)
        if (!id) return
        answered.add(id)
        if (isMarketAvailabilityPurchasable(r)) purchasable.add(id)
      })
      return offers.filter((o) => {
        const id = normalizeVariantId(o.variantId)
        return !answered.has(id) || purchasable.has(id)
      })
    } catch (e) {
      return offers
    } finally {
      clearTimeout(timer)
    }
  }

  function normalizeSku(sku) {
    return String(sku || "").trim().toLowerCase()
  }

  function normalizeProductTitle(title) {
    return String(title || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
  }

  // Never pitch something already in the bag: match by product, variant, SKU, or
  // product title (offer ids may arrive as GIDs). In List, the popup gift's
  // product is also excluded so it is not sold next to its free band.
  function filterCartDuplicates(offers, cart) {
    if (!offers || !cart) return offers || []
    const items = Array.isArray(cart.items) ? cart.items : []
    const productIds = new Set(items.map((i) => normalizeVariantId(i.product_id)))
    const variantIds = new Set(items.map((i) => normalizeVariantId(i.variant_id)))
    const skus = new Set(items.map((i) => normalizeSku(i.sku)).filter(Boolean))
    const titles = new Set(items.map((i) => normalizeProductTitle(i.product_title)).filter(Boolean))
    if (isListLayout()) {
      const giftProductId = getModal()?.querySelector("[data-ppup-gift]")?.dataset.productId
      if (giftProductId) productIds.add(normalizeVariantId(giftProductId))
    }
    return offers.filter((o) => {
      if (productIds.has(normalizeVariantId(o.productId))) return false
      if (variantIds.has(normalizeVariantId(o.variantId))) return false
      if (o.sku && skus.has(normalizeSku(o.sku))) return false
      const title = normalizeProductTitle(o.title)
      if (title && titles.has(title)) return false
      return true
    })
  }

  function removeDynamicOfferCards() {
    getPpupItemsContainer()?.querySelectorAll("[data-ppup-dynamic-item]").forEach((el) => el.remove())
  }

  // Center the desktop card row by the count of *visible* offers (market-hidden
  // or added cards stay in the DOM) — set an explicit count the grid reads.
  function syncPpupGridColumns(root) {
    const container =
      (root instanceof Element ? root.querySelector("[data-pre-upsell-paid-grid], .pre-upsell__items") : null) ||
      getPpupItemsContainer()
    if (!container) return
    const visible = Array.from(container.querySelectorAll(".pre-upsell__item")).filter(
      (el) => !el.hidden && el.getAttribute("aria-hidden") !== "true" && el.style.display !== "none",
    )
    container.dataset.ppupVisibleCount = String(Math.min(4, Math.max(1, visible.length || 1)))
  }
  window.bbeSyncPpupGridColumns = syncPpupGridColumns

  function buildDynamicOfferCard(offer, responseMeta) {
    if (isListLayout()) offer = ppupList.resolveVariantOffer(offer)
    const catalogPrice = parseFloat(offer.price)
    const compareAtParsed = parseFloat(offer.compareAtPrice)
    const currency = offer.currency || config.currency
    const hasCatalogPrice = Number.isFinite(catalogPrice) && catalogPrice > 0
    const strikethroughBase = hasCatalogPrice
      ? Number.isFinite(compareAtParsed) && compareAtParsed > catalogPrice
        ? compareAtParsed
        : catalogPrice
      : 0
    // Eligibility gate (2026-08-04): only advertise a % the Function will grant.
    // Product axis via the mirrored eligibility set; the mirror already excludes
    // tag-blocked and subscription-only products, which is the class that was
    // advertising an unhonored 30% on this surface.
    const applyScriptDisplay =
      config.useScriptDiscount &&
      config.ppupDiscountPct > 0 &&
      hasCatalogPrice &&
      isPpupProductEligible(offer)
    // Must stay identical to the upsell-price-transform Cart Transform (the price
    // checkout charges): round(unitPrice × (1 − pct/100) × 100) / 100, per unit.
    const ppupPrice = applyScriptDisplay
      ? Math.round(catalogPrice * (1 - config.ppupDiscountPct / 100) * 100) / 100
      : catalogPrice
    const hasCompare = applyScriptDisplay && strikethroughBase > ppupPrice
    if (isListLayout()) {
      const listCard = ppupList.buildListOfferCard(offer, { currency, ppupPrice, hasCompare, strikethroughBase })
      if (offer.price != null) listCard.dataset.ppupCatalogPrice = String(offer.price)
      return listCard
    }
    // Match the static card contract (bbe-upsell-offer-card.liquid): always
    // render the <s> compare element, `hidden` when there's nothing to strike.
    // getPpupCardCompareCents() reads data-ppup-compare-cents first and treats a
    // hidden compare element as 0, so the savings math stays correct either way.
    const compareHtml =
      '<s class="lp-modal-offer-card__price-was lu-card-price-was pre-upsell__item-compare_at"' +
      (hasCompare ? "" : " hidden") +
      ">" +
      (hasCompare
        ? '<span class="visually-hidden">Regular price </span>' + formatMoney(strikethroughBase, currency)
        : "") +
      "</s>"
    let rectBadgeHtml = ""
    let circleBadgeHtml = ""
    if (applyScriptDisplay) {
      if (config.ppupBadgeStyle === "dollar" && hasCompare) {
        const saveCents = Math.round((strikethroughBase - ppupPrice) * 100)
        if (saveCents > 0) {
          rectBadgeHtml =
            '<div class="lp-modal-offer-card__badges lu-card-badges">' +
            '<span class="lp-modal-offer-card__badge lp-modal-offer-card__badge--sale lu-card-badge lu-card-badge--sale">' +
            escapeHtml(formatMoney(saveCents / 100, currency) + " OFF") +
            "</span></div>"
        }
      } else if (config.ppupDiscountPct > 0) {
        circleBadgeHtml =
          '<div class="pre-upsell__dynamic-badge" aria-hidden="true">' +
          '<span class="pre-upsell__dynamic-badge-pct">' +
          escapeHtml(String(config.ppupDiscountPct) + "%") +
          "</span>" +
          '<span class="pre-upsell__dynamic-badge-off">OFF</span>' +
          "</div>"
      }
    }
    const title = escapeHtml(offer.title || "")
    const imageUrl = safeImageUrl(offer.image)
    const addAria = escapeAttr("Add " + (offer.title || "item") + " to your order")
    const removeAria = escapeAttr("Remove " + (offer.title || "item") + " from your order")
    const mediaHtml =
      '<div class="lp-modal-offer-card__img-wrap lu-card-media">' +
      circleBadgeHtml +
      (imageUrl
        ? '<img class="lp-modal-offer-card__img lu-card-img" src="' +
          imageUrl +
          '" alt="' +
          title +
          '" width="200" height="200" loading="lazy">'
        : '<span class="lp-modal-offer-card__img-ph lu-card-img-ph" aria-hidden="true">No Image</span>') +
      "</div>"
    // Same luxury markup the static PPUP card renders (lp-modal-offer-card /
    // lu-card), so dynamic offers pick up the identical grid + styling from
    // pre-upsell.css. Dynamic cards have no variant <select> and add via the
    // JS offer path, so the CTA stays a plain data-dynamic-offer button.
    const card = document.createElement("article")
    card.className = "pre-upsell__item lp-modal-offer-card lu-card"
    card.id = "preupsell-dynamic-" + offer.rank
    card.dataset.ppupDynamicItem = "true"
    card.dataset.variantId = normalizeVariantId(offer.variantId)
    card.dataset.offerId = offer.offerId
    card.dataset.rank = String(offer.rank)
    card.innerHTML =
      rectBadgeHtml +
      '<div class="lp-modal-offer-card__body lu-card-body">' +
      mediaHtml +
      '<div class="lp-modal-offer-card__info lu-card-info">' +
      '<h3 class="lp-modal-offer-card__title lu-card-title">' +
      title +
      "</h3>" +
      '<div class="lp-modal-offer-card__stars lu-card-stars" role="img" aria-label="5 star rated">' +
      '<span class="lp-modal-offer-card__stars-glyphs" aria-hidden="true">★★★★★</span>' +
      "</div>" +
      '<div class="lp-modal-offer-card__price lu-card-price pre-upsell__item-pricing">' +
      compareHtml +
      '<span class="lp-modal-offer-card__price-sale lu-card-price-sale pre-upsell__item-current-price">' +
      formatMoney(ppupPrice, currency) +
      "</span></div></div></div>" +
      '<div class="lp-modal-offer-card__action lu-card-action pre-upsell__item-action">' +
      '<div class="pre-upsell__add-state" data-pre-upsell-add-state>' +
      '<button type="button" class="pre-upsell__add-button lp-modal-offer-card__btn lu-card-btn" data-upsell-add data-dynamic-offer="true" data-default-label="ADD" aria-label="' +
      addAria +
      '" data-default-aria-label="' +
      addAria +
      '" data-remove-aria-label="' +
      removeAria +
      '">' +
      '<span class="btn-text">ADD</span></button></div>' +
      '<div class="pre-upsell__added-state" data-pre-upsell-added-state hidden aria-hidden="true"></div></div>'
    card.dataset.productId = offer.productId
    if (offer.sku) card.dataset.sku = offer.sku
    if (hasCompare) {
      card.dataset.ppupCompareCents = String(Math.round(strikethroughBase * 100))
    }
    card.dataset.ppupPriceCents = String(Math.round(ppupPrice * 100))
    if (offer.price != null) card.dataset.ppupCatalogPrice = String(offer.price)
    return card
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, "&#39;")
  }

  /** Shopify CDN only; other hosts are returned unchanged. */
  function withImageWidth(url, width) {
    const s = String(url || "").trim()
    if (!s) return s
    try {
      const parsed = new URL(s, window.location.origin)
      const isShopifyCdn =
        parsed.hostname === "cdn.shopify.com" || parsed.pathname.startsWith("/cdn/shop/")
      if (!isShopifyCdn) return s
      parsed.searchParams.set("width", String(width))
      return parsed.href
    } catch {
      return s
    }
  }

  function safeImageUrl(url) {
    const s = String(url || "").trim()
    if (!s) return ""
    try {
      const parsed = new URL(s, window.location.origin)
      if (parsed.protocol === "http:" || parsed.protocol === "https:") {
        return escapeAttr(parsed.href)
      }
    } catch (e) {
      /* reject invalid or unsafe protocols */
    }
    return ""
  }

  function renderDynamicOffers(offers, responseMeta) {
    const itemsContainer = getPpupItemsContainer()
    if (!itemsContainer) return false

    removeDynamicOfferCards()
    const sorted = [...offers].sort((a, b) => (a.rank || 0) - (b.rank || 0))
    // `productsShown` on events and `_ppup_products_shown` = cards on screen (after
    // cart / market filters and List merging), not the server's returned count.
    activeOfferResponse = { ...responseMeta, productsShown: sorted.length }
    cachedDynamicOffers = sorted
    sorted.forEach((offer) => {
      itemsContainer.appendChild(buildDynamicOfferCard(offer, responseMeta))
    })
    premintPpupOffers(sorted.flatMap((offer) => offer.variantOffers || [offer]))
    syncDynamicAddedFromCart(window.liquidAjaxCart?.cart)
    syncPpupGridColumns()
    if (isListLayout()) ppupList.renderCategoryTabs()
    return sorted.length > 0
  }

  async function postCartViewImpression() {
    const identity = resolvePpupIdentity()
    const payload = {
      type: "__cartPreupsell",
      sessionId: identity.sessionId,
      visitorKey: identity.visitorKey,
    }
    try {
      await fetch(CART_VIEW_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      })
    } catch (e) {
      /* best-effort */
    }
  }

  async function postOfferEvent(eventType, offer, responseMeta, extra) {
    const identity = resolvePpupIdentity()
    try {
      await fetch(EVENT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          contractVersion: "ppup-v1",
          eventType,
          sessionId: identity.sessionId,
          visitorKey: identity.visitorKey,
          mode: responseMeta?.mode || "dynamic",
          experimentVariant: responseMeta?.experimentVariant || null,
          algorithmVersion: responseMeta?.algorithmVersion || "v1",
          offerId: offer?.offerId || null,
          productId: offer?.productId || null,
          variantId: offer?.variantId || null,
          sku: offer?.sku || null,
          rank: offer?.rank || null,
          price: offer?.price || null,
          currency: offer?.currency || config.currency,
          fallbackUsed: responseMeta?.fallbackUsed || false,
          fallbackReason: responseMeta?.fallbackReason || "none",
          productsShown: responseMeta?.productsShown || null,
          country: config.country,
          device: getDeviceType(),
          ...getPpupLayoutFields(),
          reason: extra?.reason || (ppupListFailed ? "list_assets_failed" : null),
        }),
      })
    } catch (e) {
      /* best-effort */
    }
  }

  function openUpsell(invoker) {
    const modalEl = getModal()
    if (!modalEl) return
    if (typeof modalEl.open === "function") {
      modalEl.open(invoker || null)
      // open() can decline (page Off / no eligible card) and navigate instead.
      if (modalEl.classList.contains("show")) postCartViewImpression()
      return
    }
    modalEl.classList.add("show")
    getPpupOverlay()?.classList.add("show")
    postCartViewImpression()
  }

  function closeUpsellVisual() {
    const modalEl = getModal()
    if (!modalEl) return
    modalEl.classList.add("fading")
    getPpupOverlay()?.classList.remove("show")
    setTimeout(() => modalEl.classList.remove("show", "fading"), 220)
  }

  function goToCheckout() {
    clearAddedOverlays()
    window.location.href = getCheckoutUrl()
  }

  /**
   * Fetch the session's offers, drop in-cart / not-purchasable ones, and render
   * the cards. Does not open the modal. Any failure (API error, 3s abort,
   * `suppress`, legacy `mode:"static"`, nothing left after filters) returns
   * `skip` so callers continue to checkout — there is no static popup.
   */
  async function prepareDynamicOffers() {
    try {
      // Before the offers request: the app logs impressions server-side when it answers.
      if (getPpupLayoutState().layout === "off") {
        reportPpupPageOff()
        return { action: "skip" }
      }

      // One /cart.js read per checkout click, shared by every step below.
      let cart
      try {
        cart = await fetchCart()
      } catch (e) {
        return { action: "skip" }
      }
      if (hasNonCombinableRewardDiscount(cart)) return { action: "skip" }

      const offersResponse = await fetchOffersWithTimeout(cart)
      if (!offersResponse || offersResponse.mode === "static") return { action: "skip" }

      if (offersResponse.suppress || !offersResponse.offers?.length) {
        postOfferEvent("suppressed", null, offersResponse)
        return { action: "skip" }
      }

      if (getPpupLayoutState().layout === "list_v2" && !ppupListActive) {
        await Promise.race([ensureListAssets(), wait(LIST_ASSET_WAIT_MS)])
        if (!ppupListActive) {
          markListFailed()
          reportListFallback(offersResponse)
        }
      }
      let offers = filterCartDuplicates(offersResponse.offers, cart)
      // List cards need product type / handle / blurb (not in the offer payload);
      // look them up alongside the market check and cap the wait.
      const enrichment = isListLayout() ? ppupList.enrichListOffers(offers) : null
      offers = await filterByMarketAvailability(offers)
      if (offers.length === 0) return { action: "skip" }
      if (isListLayout()) {
        offers = ppupList.collapseParentSizeOffers(offers)
        offers = ppupList.groupVariantOffers(offers)
      }
      if (enrichment) await Promise.race([enrichment, wait(LIST_ENRICH_WAIT_MS)])

      const rendered = renderDynamicOffers(offers.slice(0, config.maxOffers), offersResponse)
      if (rendered && enrichment) {
        ppupList.renderListChrome(cart)
        enrichment.then(ppupList.patchListCardsFromInfo)
      }
      return rendered ? { action: "open" } : { action: "skip" }
    } catch (e) {
      return { action: "skip" }
    }
  }

  // Shared with the cart-drawer gate (`bbeResolvePreUpsellCheckout`) so LP
  // checkouts use the same app offers as the drawer.
  window.bbePreparePreUpsellOffers = prepareDynamicOffers

  async function handleDynamicCheckoutPath() {
    const outcome = await prepareDynamicOffers()
    if (outcome.action !== "open") {
      goToCheckout()
      return
    }
    document.querySelector("cart-drawer")?.close?.()
    openUpsell()
  }

  function setDrawerCheckoutLoading(loading) {
    const drawer = document.querySelector("cart-drawer")
    if (drawer) {
      drawer.classList.toggle("cart-loading", loading)
    }
    document.querySelectorAll(".cart-drawer__button").forEach((btn) => {
      btn.setAttribute("aria-busy", loading ? "true" : "false")
    })
  }

  function runCheckoutIntercept() {
    checkoutInterceptBusy = true
    setDrawerCheckoutLoading(true)

    const done = () => {
      checkoutInterceptBusy = false
        if (checkoutInterceptQueued) {
        checkoutInterceptQueued = false
        if (getModal()?.classList.contains("show")) {
          setDrawerCheckoutLoading(false)
          return
        }
        runCheckoutIntercept()
        return
      }
      setDrawerCheckoutLoading(false)
    }

    handleDynamicCheckoutPath().finally(done)
  }

  function handleCartCheckoutIntercept(e) {
    if (e.target.closest("pre-upsell-modal")) return

    const trigger = e.target.closest(
      ".cart-drawer__button, [data-cart-drawer-checkout], [data-checkout-button], button[name=\"checkout\"]",
    )
    if (!trigger) return

    if (document.querySelector('.bbe-collection-cart-gates[data-hide-pre-purchase-upsell="true"]')) {
      const checkoutUrl = trigger.dataset.checkoutUrl || getCheckoutUrl()
      if (typeof window.bbeSkipPreUpsellToCheckout === "function") {
        window.bbeSkipPreUpsellToCheckout(checkoutUrl)
      } else {
        window.location.href = checkoutUrl
      }
      return
    }

    e.preventDefault()
    e.stopImmediatePropagation()

    if (checkoutInterceptBusy) {
      checkoutInterceptQueued = true
      setDrawerCheckoutLoading(true)
      return
    }

    runCheckoutIntercept()
  }

  /**
   * The section loads pre-upsell-modal.js deferred; inject it if a page builder
   * dropped that tag. Deferred scripts all run before DOMContentLoaded, so check
   * after it. Returns false only when the legacy exit handlers must be bound.
   */
  function ensurePreUpsellModalElement() {
    if (window.__bbePreUpsellElementDefined || window.customElements?.get("pre-upsell-modal")) return true
    const nav = performance.getEntriesByType?.("navigation")?.[0]
    const domContentLoaded = document.readyState === "complete" || Boolean(nav && nav.domContentLoadedEventStart > 0)
    if (!domContentLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        () => {
          if (!ensurePreUpsellModalElement()) setupCheckoutExits()
        },
        { once: true },
      )
      return true
    }
    if (document.querySelector("script[data-ppup-modal-loader]")) return true
    const src = getModal()?.dataset.preUpsellModalSrc
    if (!src) return false
    const script = document.createElement("script")
    script.src = src
    script.dataset.ppupModalLoader = ""
    script.onerror = setupCheckoutExits
    document.head.appendChild(script)
    return true
  }

  function setupCheckoutExits() {
    if (checkoutExitHandlersBound) return
    if (window.__bbePreUpsellElementDefined) return
    checkoutExitHandlersBound = true

    document.querySelector(".pre-upsell__wrapper")?.addEventListener("click", (e) => {
      const checkoutLink = e.target.closest("[data-upsell-checkout]")
      if (checkoutLink) {
        e.preventDefault()
        goToCheckout()
        return
      }

      const closeBtn = e.target.closest(".pre-upsell__close")
      if (closeBtn) {
        e.preventDefault()
        closeUpsellVisual()
        setTimeout(goToCheckout, 180)
      }
    })

    getPpupOverlay()?.addEventListener("click", (e) => {
      e.preventDefault()
      closeUpsellVisual()
      setTimeout(goToCheckout, 180)
    })

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.classList.contains("show")) {
        closeUpsellVisual()
        setTimeout(goToCheckout, 180)
      }
    })
  }

  function buildDynamicLineProperties(offer, responseMeta) {
    const props = {
      // Canonical location marker (analytics + cart merge backfill).
      _is_prepurchase_popup_upsell: "true",
      __cartPreupsell: "true",
      _ppup_mode: "dynamic",
      __ppup_session_id: getOrCreateSessionId(),
      _ppup_offer_id: offer.offerId || "",
      _ppup_algo_version: responseMeta?.algorithmVersion || "v1",
      _ppup_fallback_used: String(responseMeta?.fallbackUsed === true),
      _ppup_fallback_reason: responseMeta?.fallbackReason || "none",
      _ppup_products_shown: String(responseMeta?.productsShown ?? (responseMeta?.offers?.length || 0)),
      _ppup_rank: String(offer.rank || ""),
      ...getShownLayoutLineProps(),
      __track_source: "pre_purchase_popup_upsell",
      __track_event: "prePurchasePopupUpsellAdd",
      __track_slot: String(offer.rank || ""),
    }

    // Price marker read by the upsell-price-transform Cart Transform (and by
    // PPUP_4YOU's PPUP branch, which stands down while the transform owns PPUP).
    // Distinct from the analytics marker above — dropping it bills full price.
    if (config.useScriptDiscount) {
      props._is_pre_purchase_popup_upsell = "true"
    }

    // Theme-authorized qty: the upsell-line-validation checkout Function
    // blocks upsell lines whose quantity exceeds this, so the checkout qty
    // stepper cannot inflate discounted offer lines. PPUP adds are qty 1.
    props._upsell_qty = "1"

    // Dual-write signed `_bbe_offer` when premint cache is warm (never block ATC).
    try {
      const offerId = offer.offerId || `ppup-${offer.variantId || "x"}`
      const key = offerMintCacheKey(offerId, offer.variantId, 1)
      const token = readOfferMintCache(key)
      if (token) props._bbe_offer = token
    } catch {
      /* ignore */
    }

    return props
  }

  /** A variant that failed its add-time re-check must not come back on the next rebuild. */
  function dropCachedOfferVariant(variantId) {
    const id = normalizeVariantId(variantId)
    if (!id || !cachedDynamicOffers) return
    cachedDynamicOffers = cachedDynamicOffers
      .map((offer) => {
        const options = offer.variantOffers
        if (!options) return normalizeVariantId(offer.variantId) === id ? null : offer
        const rest = options.filter((o) => normalizeVariantId(o.variantId) !== id)
        if (!rest.length) return null
        if (rest.length === 1) return { ...rest[0], rank: offer.rank }
        return { ...rest[0], rank: offer.rank, variantOffers: rest }
      })
      .filter(Boolean)
  }

  async function revalidateOfferVariant(offer) {
    const filtered = await filterByMarketAvailability([offer])
    return filtered.length > 0
  }

  async function addDynamicOffer(offer, btn) {
    const responseMeta = activeOfferResponse
    if (!await revalidateOfferVariant(offer)) {
      const card = btn.closest(".pre-upsell__item")
      if (card) card.remove()
      dropCachedOfferVariant(offer.variantId)
      return null
    }

    const properties = buildDynamicLineProperties(offer, responseMeta)
    const body = {
      items: [
        {
          id: Number(normalizeVariantId(offer.variantId)),
          quantity: 1,
          properties,
        },
      ],
    }

    postOfferEvent("add_attempt", offer, responseMeta)

    const cartBody = await cartAddViaAjaxCart(body, {
      info: { should_keep_drawer_closed: true, initiator: btn },
    })

    return cartBody || null
  }

  function setPpupAtcLoading(btn, loading) {
    if (typeof window.bbeSetCartAtcLoading === "function") {
      window.bbeSetCartAtcLoading(btn, loading)
      return
    }
    if (!(btn instanceof HTMLElement)) return
    const card = btn.closest(".pre-upsell__item")
    const cardAdded = card?.classList.contains("added")
    if (loading) {
      btn.setAttribute("aria-busy", "true")
      btn.classList.add("loading", "bbe-cart-loading", "bbe-cart-loading--on-dark")
      if (btn instanceof HTMLButtonElement) btn.disabled = true
      return
    }
    btn.removeAttribute("aria-busy")
    btn.classList.remove("loading", "bbe-cart-loading", "bbe-cart-loading--on-dark")
    if (btn instanceof HTMLButtonElement && !cardAdded) btn.disabled = false
  }

  /**
   * A failed ADD used to only console.error and clear the spinner, which on
   * mobile reads as "the button does nothing." Surface the failure on the card
   * (role=alert line + temporary button label) so the shopper gets feedback.
   */
  function showPpupAddError(btn, message) {
    const text =
      typeof message === "string" && message.trim() && !/^cart add failed$/i.test(message.trim())
        ? message.trim()
        : PPUP_ADD_ERROR_FALLBACK_MSG

    const card = btn instanceof Element ? btn.closest(".pre-upsell__item") : null
    if (card) {
      let slot = card.querySelector("[data-ppup-add-error]")
      if (!slot) {
        slot = document.createElement("p")
        slot.className = "pre-upsell__add-error"
        slot.setAttribute("data-ppup-add-error", "")
        slot.setAttribute("role", "alert")
        const anchor = btn.closest("form") || btn
        anchor.insertAdjacentElement("afterend", slot)
      }
      slot.textContent = text
      slot.classList.add("is-visible")
      if (card.__ppupAddErrorTimer) clearTimeout(card.__ppupAddErrorTimer)
      card.__ppupAddErrorTimer = setTimeout(() => {
        slot.classList.remove("is-visible")
        slot.textContent = ""
      }, PPUP_ADD_ERROR_RESET_MS)
    }

    if (btn instanceof HTMLElement) btn.title = text
  }

  function resolvePpupRemovePayload(btn) {
    if (!(btn instanceof HTMLAnchorElement)) return null
    const lineKey = String(btn.dataset.lineKey || btn.dataset.id || "").trim()
    if (lineKey) return { id: lineKey, quantity: 0 }

    const removeUrl = String(
      btn.getAttribute("data-ajax-cart-request-button") || btn.getAttribute("href") || "",
    ).trim()
    if (!removeUrl || removeUrl === "#") return null

    try {
      const parsed = new URL(removeUrl, window.location.origin)
      const id = parsed.searchParams.get("id")
      if (id) return { id, quantity: 0 }
    } catch {
      return null
    }
    return null
  }

  function onUpsellRemoveClick(e) {
    const btn = e.target.closest("pre-upsell-modal [data-upsell-remove]")
    if (!(btn instanceof HTMLAnchorElement)) return

    const modal = btn.closest("pre-upsell-modal")
    if (!modal?.classList.contains("show")) return

    const payload = resolvePpupRemovePayload(btn)
    if (!payload || typeof window.liquidAjaxCart?.change !== "function") return

    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    if (btn.getAttribute("aria-busy") === "true") return

    setPpupAtcLoading(btn, true)

    const card = btn.closest(".pre-upsell__item")

    window.liquidAjaxCart.change(payload, {
      important: true,
      info: { should_keep_drawer_closed: true, initiator: btn },
      lastCallback: (requestState) => {
        setPpupAtcLoading(btn, false)
        if (requestState?.responseData?.ok !== true) return

        if (card instanceof Element && typeof window.bbeResetPreUpsellCard === "function") {
          window.bbeResetPreUpsellCard(card)
        }
        updateDynamicSavings()

        // Analytics: record the removal so the upsell funnel is complete
        // (impression → add → remove). Client beacon is deduped-off so every
        // remove counts; matches the __removed_selling_plan pattern.
        if (typeof window.recordCartStat === "function") {
          window.recordCartStat("__cartPreupsell_upsell_removed", { dedupe: false })
        }

      },
    })
  }

  function resolvePpupLineKeyFromCard(card, btn) {
    if (!(card instanceof Element)) return ""
    const stored = String(
      btn?.dataset?.lineKey ||
        card.dataset.ppupLineKey ||
        card.querySelector('[data-upsell-remove]')?.dataset?.lineKey ||
        "",
    ).trim()
    if (stored) return stored

    // Fallback: an added card can lose its stored key across section
    // re-renders. Resolve from the live cart by variant id so the ✓ ADDED
    // undo tap never silently no-ops.
    const variantId = normalizeVariantId(card.dataset.variantId || "")
    if (!variantId) return ""
    const line = (window.liquidAjaxCart?.cart?.items || []).find(
      (item) => String(item.variant_id) === variantId && !isLpPpUpsellFreeLine(item),
    )
    return line?.key ? String(line.key) : ""
  }

  function onUpsellAddedUndoClick(e) {
    const btn = e.target.closest("pre-upsell-modal button[data-upsell-add].is-added")
    if (!(btn instanceof HTMLButtonElement)) return

    const modal = btn.closest("pre-upsell-modal")
    if (!modal?.classList.contains("show")) return

    const card = btn.closest(".pre-upsell__item")
    const lineKey = resolvePpupLineKeyFromCard(card, btn)
    if (!lineKey) {
      // Line is no longer in the cart (removed elsewhere) — reset the card to
      // ADD instead of leaving a dead ✓ ADDED button.
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      if (card instanceof Element && typeof window.bbeResetPreUpsellCard === "function") {
        window.bbeResetPreUpsellCard(card)
      }
      return
    }
    if (typeof window.liquidAjaxCart?.change !== "function") return

    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    if (btn.getAttribute("aria-busy") === "true") return

    setPpupAtcLoading(btn, true)

    window.liquidAjaxCart.change(
      { id: lineKey, quantity: 0 },
      {
        important: true,
        info: { should_keep_drawer_closed: true, initiator: btn },
        lastCallback: (requestState) => {
          setPpupAtcLoading(btn, false)
          if (requestState?.responseData?.ok !== true) return

          if (card instanceof Element && typeof window.bbeResetPreUpsellCard === "function") {
            window.bbeResetPreUpsellCard(card)
          }
          updateDynamicSavings()

          if (typeof window.recordCartStat === "function") {
            window.recordCartStat("__cartPreupsell_upsell_removed", { dedupe: false })
          }
        },
      },
    )
  }

  async function onUpsellAddClick(e) {
    const btn = e.target.closest("[data-upsell-add]")
    if (!btn) return
    if (btn.classList.contains("is-added")) {
      onUpsellAddedUndoClick(e)
      return
    }
    if (btn.disabled || btn.getAttribute("aria-busy") === "true") return
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    const card = btn.closest(".pre-upsell__item")
    if (card?.dataset.ppupFreeItem === "true") {
      if (countLpPpUpsellFreeLines(window.liquidAjaxCart?.cart) >= 1) {
        showPpupAddError(btn, PPUP_FREE_GIFT_LIMIT_MSG)
        syncPpupFreeCardLimits(getModal())
        return
      }
    }

    if (btn.dataset.dynamicOffer === "true") {
      const offer = {
        offerId: card?.dataset.offerId,
        variantId: card?.dataset.variantId,
        rank: Number(card?.dataset.rank || 0),
        productId: card?.dataset.productId,
        sku: card?.dataset.sku || null,
        price: card?.dataset.ppupCatalogPrice || null,
      }
      setPpupAtcLoading(btn, true)
      try {
        const cartBody = await addDynamicOffer(offer, btn)
        if (!cartBody) {
          setPpupAtcLoading(btn, false)
          return
        }
        if (card) {
          const paidLine = findCartLineByVariantId(cartBody, offer.variantId)
          if (paidLine && typeof window.bbeSetPreUpsellAddedState === "function") {
            window.bbeSetPreUpsellAddedState(card, paidLine)
          } else if (paidLine) {
            card.classList.add("added")
            const btnText = btn.querySelector(".btn-text")
            if (btnText) btnText.textContent = PPUP_ADDED_LABEL
            btn.classList.add("is-added")
            btn.disabled = false
            btn.style.opacity = "1"
          }
          updateDynamicSavings(true)
        }
        setPpupAtcLoading(btn, false)
      } catch (err) {
        console.error(err)
        setPpupAtcLoading(btn, false)
        showPpupAddError(btn, err && err.message)
      }
      return
    }
  }

  let ppupSavingsHideTimer = null

  function parsePpupPriceText(el) {
    if (!(el instanceof Element)) return 0
    const raw = (el.textContent || "").replace(/[^0-9.-]/g, "")
    const dollars = parseFloat(raw)
    return Number.isFinite(dollars) ? Math.round(dollars * 100) : 0
  }

  function getPpupCardPriceCents(card) {
    const fromData = parseInt(card.dataset.ppupPriceCents, 10)
    if (Number.isFinite(fromData) && fromData > 0) return fromData
    return parsePpupPriceText(
      card.querySelector(".pre-upsell__item-current-price, .lp-modal-offer-card__price-sale"),
    )
  }

  function getPpupCardCompareCents(card) {
    const fromData = parseInt(card.dataset.ppupCompareCents, 10)
    if (Number.isFinite(fromData) && fromData > 0) return fromData
    const compareEl = card.querySelector(".pre-upsell__item-compare_at, .lp-modal-offer-card__price-was")
    if (compareEl instanceof HTMLElement && compareEl.hidden) return 0
    return parsePpupPriceText(compareEl)
  }

  function calcPpupTotalSavingsCents(root) {
    const scope = root instanceof Element ? root : document.querySelector("pre-upsell-modal")
    if (!scope) return 0

    let totalCents = 0
    scope.querySelectorAll(".pre-upsell__item.added").forEach((card) => {
      const compareCents = getPpupCardCompareCents(card)
      const priceCents = getPpupCardPriceCents(card)
      if (compareCents > priceCents) {
        totalCents += compareCents - priceCents
      }
    })
    return totalCents
  }

  function getOrCreatePpupSavingsEl(root) {
    const scope = root instanceof Element ? root : document.querySelector("pre-upsell-modal")
    if (!scope) return null

    let savingsEl = scope.querySelector(".pre-upsell__save-amount")
    if (savingsEl) return savingsEl

    const footer = scope.querySelector(".pre-upsell__footer")
    const checkoutBtn = scope.querySelector(".pre-upsell__footer-button")
    if (!footer || !checkoutBtn) return null

    savingsEl = document.createElement("p")
    savingsEl.className = "pre-upsell__save-amount"
    savingsEl.setAttribute("role", "status")
    savingsEl.setAttribute("aria-live", "polite")
    savingsEl.setAttribute("aria-atomic", "true")
    footer.insertBefore(savingsEl, checkoutBtn)
    return savingsEl
  }

  function hidePpupSavingsEl(savingsEl, immediate) {
    if (!(savingsEl instanceof HTMLElement)) return
    if (ppupSavingsHideTimer) {
      clearTimeout(ppupSavingsHideTimer)
      ppupSavingsHideTimer = null
    }

    savingsEl.classList.remove("is-visible")

    if (immediate) {
      savingsEl.classList.remove("is-hiding")
      savingsEl.style.display = "none"
      return
    }

    savingsEl.classList.add("is-hiding")
    window.setTimeout(() => {
      if (!savingsEl.classList.contains("is-visible")) {
        savingsEl.style.display = "none"
        savingsEl.classList.remove("is-hiding")
      }
    }, 450)
  }

  function showPpupSavingsPulse(savingsEl, totalCents) {
    if (!(savingsEl instanceof HTMLElement) || totalCents <= 0) return

    if (ppupSavingsHideTimer) {
      clearTimeout(ppupSavingsHideTimer)
      ppupSavingsHideTimer = null
    }

    const formatted = formatMoney(totalCents / 100, config.currency)
    savingsEl.innerHTML = "You're saving <span>" + formatted + "</span>."
    savingsEl.style.display = "block"
    savingsEl.classList.remove("is-hiding")
    void savingsEl.offsetWidth
    savingsEl.classList.add("is-visible")

    ppupSavingsHideTimer = window.setTimeout(() => {
      hidePpupSavingsEl(savingsEl, false)
      ppupSavingsHideTimer = null
    }, 3000)
  }

  function showPpupSavingsSticky(savingsEl, totalCents, animate) {
    if (ppupSavingsHideTimer) {
      clearTimeout(ppupSavingsHideTimer)
      ppupSavingsHideTimer = null
    }
    const formatted = formatMoney(totalCents / 100, config.currency)
    const changed = savingsEl.dataset.cents !== String(totalCents)
    const wasVisible = savingsEl.classList.contains("is-visible")
    savingsEl.dataset.cents = String(totalCents)
    if (changed || !wasVisible) {
      savingsEl.innerHTML = "You’re saving <span>" + formatted + "</span> on add-ons"
    }
    savingsEl.style.display = "block"
    savingsEl.classList.remove("is-hiding")
    if (!wasVisible) {
      void savingsEl.offsetWidth
      savingsEl.classList.add("is-visible")
    }
    if (animate && changed && wasVisible) {
      savingsEl.classList.remove("is-pop")
      void savingsEl.offsetWidth
      savingsEl.classList.add("is-pop")
    }
  }

  function updatePpupSavings(opts = {}) {
    const root = opts.root instanceof Element ? opts.root : getModal()
    if (!root) return

    const animate = opts.animate === true
    const totalCents = calcPpupTotalSavingsCents(root)
    const savingsEl = getOrCreatePpupSavingsEl(root)
    if (!savingsEl) return

    if (totalCents <= 0) {
      hidePpupSavingsEl(savingsEl, true)
      return
    }

    // List keeps the line up while add-ons are in the cart; Grid pulses for 3s.
    if (document.documentElement.dataset.ppupLayout === "list_v2") {
      showPpupSavingsSticky(savingsEl, totalCents, animate)
      return
    }

    if (animate) {
      showPpupSavingsPulse(savingsEl, totalCents)
      return
    }

    // Silent path (sync/remove) — keep hidden unless a pulse is active.
    if (!savingsEl.classList.contains("is-visible") && !savingsEl.classList.contains("is-hiding")) {
      hidePpupSavingsEl(savingsEl, true)
    }
  }

  function updateDynamicSavings(animate) {
    updatePpupSavings({ animate: animate === true, root: getModal() })
  }

  window.bbeUpdatePpupSavings = updatePpupSavings

  function clearAddedOverlays() {
    document.querySelectorAll(".pre-upsell__item.added").forEach((card) => {
      if (typeof window.bbeResetPreUpsellCard === "function") {
        window.bbeResetPreUpsellCard(card)
        return
      }
      card.classList.remove("added")
      const button = card.querySelector("button[data-upsell-add]")
      if (button) {
        const btnText = button.querySelector(".btn-text")
        if (btnText) btnText.textContent = "ADD"
        button.disabled = false
        button.style.opacity = "1"
      }
    })

    const savingsEl = document.querySelector(".pre-upsell__save-amount")
    if (savingsEl) hidePpupSavingsEl(savingsEl, true)
  }

  // --- List layout (list_v2) loader -------------------------------------------
  // The List code and styles are assets/pre-upsell-list.{js,css}, fetched at boot
  // only when this page resolves to list_v2. Prepare waits LIST_ASSET_WAIT_MS more
  // at most; if they are still missing, this page view shows Grid (line props say
  // grid_v1/fallback; events keep the assigned layout with reason list_assets_failed).
  const LIST_ENRICH_WAIT_MS = 700
  const LIST_ASSET_WAIT_MS = 400
  let ppupList = null
  let ppupListFactory = null
  let ppupListCssReady = false
  let ppupListActive = false
  let ppupListFailed = false
  let ppupListAssets = null
  let resolveListAssets = null

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  function listCoreApi() {
    return {
      config,
      getModal,
      isListLayout,
      isCheckoutBusy: () => checkoutInterceptBusy,
      getShownLayoutLineProps,
      getPpupItemsContainer,
      cartAddViaAjaxCart,
      onUpsellAddClick,
      rerenderOffers: () => handlePpupSectionRefresh({ force: true }),
      offerMintCacheKey,
      readOfferMintCache,
      postOfferMint,
      getGiftGateDollars,
      lineIsServerFree,
      formatMoney,
      normalizeVariantId,
      escapeHtml,
      escapeAttr,
      withImageWidth,
      safeImageUrl,
      PPUP_ADDED_LABEL,
      PPUP_ADD_ERROR_FALLBACK_MSG,
      PPUP_GIFT_PROP,
      PPUP_GIFT_UNAVAILABLE_PREFIX,
      isPpupProductEligible,
    }
  }

  function activateListIfReady() {
    if (ppupListActive || ppupListFailed || !ppupListFactory || !ppupListCssReady) return
    try {
      ppupList = ppupListFactory(listCoreApi())
      ppupList.init()
      ppupListActive = true
    } catch {
      ppupList = null
      markListFailed()
    }
    resolveListAssets?.(ppupListActive)
  }

  function registerPpupList(factory) {
    if (typeof factory !== "function" || ppupListFactory) return
    ppupListFactory = factory
    activateListIfReady()
  }

  /** Once per page view; the assigned layout stays list_v2 for analytics. */
  function markListFailed() {
    if (ppupListActive || ppupListFailed) return
    ppupListFailed = true
    document.documentElement.dataset.ppupLayout = "grid_v1"
    resolveListAssets?.(false)
  }

  function ensureListAssets() {
    if (ppupListAssets) return ppupListAssets
    ppupListAssets = new Promise((resolve) => {
      resolveListAssets = resolve
    })
    const modalEl = getModal()
    const jsSrc = modalEl?.dataset.ppupListJs
    const cssHref = modalEl?.dataset.ppupListCss
    if (!jsSrc || !cssHref) {
      markListFailed()
      return ppupListAssets
    }

    window.__bbeRegisterPpupList = registerPpupList
    if (typeof window.__bbePpupListFactory === "function") registerPpupList(window.__bbePpupListFactory)

    let link = document.querySelector("link[data-ppup-list-css]")
    if (link?.sheet) {
      ppupListCssReady = true
    } else {
      if (!link) {
        link = document.createElement("link")
        link.rel = "stylesheet"
        link.href = cssHref
        link.dataset.ppupListCss = ""
        // Right after pre-upsell.css so cascade order matches the old single file.
        const base = document.querySelector('link[href*="/pre-upsell.css"]')
        if (base?.parentNode) base.parentNode.insertBefore(link, base.nextSibling)
        else document.head.appendChild(link)
      }
      link.addEventListener("load", () => {
        ppupListCssReady = true
        activateListIfReady()
      })
      link.addEventListener("error", markListFailed)
    }

    if (!ppupListFactory && !document.querySelector("script[data-ppup-list-js]")) {
      const script = document.createElement("script")
      script.src = jsSrc
      script.async = true
      script.dataset.ppupListJs = ""
      script.onerror = markListFailed
      document.head.appendChild(script)
    }
    activateListIfReady()
    return ppupListAssets
  }

  /** Fallback-rate numerator: one `fallback` event per page view that showed Grid instead of List. */
  let ppupListFallbackReported = false
  function reportListFallback(offersResponse) {
    if (ppupListFallbackReported) return
    ppupListFallbackReported = true
    postOfferEvent("fallback", null, offersResponse, { reason: "list_assets_failed" })
  }

  /** What the shopper actually saw, for cart line properties. */
  function getShownLayoutLineProps() {
    const { layout, source } = getPpupLayoutState()
    if (layout === "list_v2" && !ppupListActive) return { _ppup_layout: "grid_v1", _ppup_layout_src: "fallback" }
    return { _ppup_layout: layout, _ppup_layout_src: source }
  }

  // --- Popup gift lines (cart-wide cleanup; List UI is in pre-upsell-list.js) ---
  const PPUP_GIFT_PROP = "_ppup_gift"
  const PPUP_GIFT_UNAVAILABLE_PREFIX = "bbe_ppup_gift_unavailable:"
  const ppupGiftCleanupKeys = new Set()
  /** Per cart line: a removal that keeps failing must not loop on every cart event. */
  const ppupGiftCleanupAttempts = new Map()
  const PPUP_GIFT_CLEANUP_MAX_ATTEMPTS = 2

  function getGiftGateDollars(cart) {
    if (typeof window.bbeComputeGiftThresholdSubtotalDollars === "function" && Array.isArray(cart?.items)) {
      const dollars = Number(window.bbeComputeGiftThresholdSubtotalDollars(cart))
      if (Number.isFinite(dollars)) return dollars
    }
    const cents = Number(document.querySelector("[data-cart-gift-gate-cents]")?.dataset.cartGiftGateCents)
    return Number.isFinite(cents) ? cents / 100 : null
  }

  function lineIsServerFree(line) {
    const finalPrice = Number(line?.final_line_price)
    if (Number.isFinite(finalPrice) && finalPrice <= 0) return true
    const original = Number(line?.original_line_price)
    if (!Number.isFinite(original) || original <= 0) return false
    const allocated = (line?.line_level_discount_allocations || []).reduce(
      (sum, a) => sum + (Number(a?.amount) > 0 ? Number(a.amount) : 0),
      0,
    )
    return allocated >= original
  }

  function markGiftUnavailable(variantId) {
    try {
      sessionStorage.setItem(PPUP_GIFT_UNAVAILABLE_PREFIX + variantId, "1")
    } catch {
      /* ignore */
    }
  }

  // Runs on every cart change, popup open or not: a popup gift line the server
  // charges for (cart fell below its tier, or the Function refused it) is
  // removed. The drawer's own gift cleanup only knows drawer gifts.
  function cleanupPopupGiftLines(event) {
    const cart = event?.detail?.cart
    if (!Array.isArray(cart?.items) || typeof window.liquidAjaxCart?.change !== "function") return
    const gate = getGiftGateDollars(cart)
    cart.items.forEach((line) => {
      const marker = line.properties?.[PPUP_GIFT_PROP]
      if (!marker || lineIsServerFree(line)) return
      const key = String(line.key || "")
      if (!key || ppupGiftCleanupKeys.has(key)) return
      const attempts = ppupGiftCleanupAttempts.get(key) || 0
      if (attempts >= PPUP_GIFT_CLEANUP_MAX_ATTEMPTS) return
      ppupGiftCleanupAttempts.set(key, attempts + 1)
      ppupGiftCleanupKeys.add(key)
      const tier = Number(marker)
      // Charged while the cart is still above its tier: don't offer it again this session.
      if (gate != null && Number.isFinite(tier) && gate >= tier) markGiftUnavailable(String(line.variant_id))
      window.liquidAjaxCart.change(
        { id: key, quantity: 0 },
        {
          info: { is_automatic: true, bbePpupGiftCleanup: true },
          lastCallback: () => ppupGiftCleanupKeys.delete(key),
        },
      )
    })
  }

  function initPreUpsell() {
    applyPpupLayoutAttribute()

    if (config.enableDynamic) {
      captureAttributionOnLoad()
    }

    document.removeEventListener("click", handleCartCheckoutIntercept, true)
    document.addEventListener("click", handleCartCheckoutIntercept, true)

    document.removeEventListener("click", onUpsellAddClick, true)
    document.addEventListener("click", onUpsellAddClick, true)

    document.removeEventListener("click", onUpsellRemoveClick, true)
    document.addEventListener("click", onUpsellRemoveClick, true)

    document.removeEventListener("liquid-ajax-cart:request-end", handlePpupSectionRefresh)
    document.addEventListener("liquid-ajax-cart:request-end", handlePpupSectionRefresh)

    document.removeEventListener("liquid-ajax-cart:request-end", cleanupPopupGiftLines)
    document.addEventListener("liquid-ajax-cart:request-end", cleanupPopupGiftLines)
    if (getPpupLayoutState().layout === "list_v2") ensureListAssets()

    if (!ensurePreUpsellModalElement()) setupCheckoutExits()
    syncPpupFreeCardLimits(getModal())
  }

  // Cart updates keep the rendered rows (pre-upsell-modal.js syncs added state);
  // rows are rebuilt only when they are missing or `force` (variant pick) asks.
  // A rebuild mid-add re-enabled ADD (double adds) and dropped focus.
  function handlePpupSectionRefresh(opts) {
    if (!config.enableDynamic || !cachedDynamicOffers?.length || !activeOfferResponse) return
    const force = opts?.force === true
    const modalEl = getModal()
    if (!modalEl) return
    if (!modalEl.classList.contains("show") && !checkoutInterceptBusy) return
    requestAnimationFrame(() => {
      const liveModal = getModal()
      if (!liveModal) return
      if (!liveModal.classList.contains("show") && !checkoutInterceptBusy) return
      const rendered = getPpupItemsContainer()?.querySelectorAll("[data-ppup-dynamic-item]").length || 0
      if (!force && rendered >= cachedDynamicOffers.length) return
      renderDynamicOffers(cachedDynamicOffers, activeOfferResponse)
      syncDynamicAddedFromCart(window.liquidAjaxCart?.cart)
      syncPpupFreeCardLimits(liveModal)
    })
  }

  window.__bbePreUpsellRunCheckoutIntercept = runCheckoutIntercept

  initPreUpsell()
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootPreUpsellDynamicRuntime)
  } else {
    bootPreUpsellDynamicRuntime()
  }
})()
